import { ClientHybrid } from '@/models/client.model';
import { BinderService } from '@/services/api/binder.service';
import { ClientService } from '@/services/api/client.service';
import { CommonModule, NgIf } from '@angular/common';
import { Component, effect, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { MenuModule } from 'primeng/menu';
import { RippleModule } from 'primeng/ripple';
import { SkeletonModule } from 'primeng/skeleton';
import { TagModule } from 'primeng/tag';
import { DocDataService } from 'src/app/services/app/doc-data.service';

@Component({
    selector: 'app-binder-clients',
    imports: [TagModule, SkeletonModule, CommonModule, SelectModule, MenuModule, ButtonModule, RippleModule, FormsModule],
    template: `
    <div class="flex flex-col gap-4 card">

      <div class="flex flex-col gap-4 ">
      <div class="info-action-row">
        <div class="ml-2 md:mr-2 flex">
            <div class="mr-0 md:mr-1">
            <h2 class="text-2xl font-bold">Clients</h2>
            </div>
        </div>
        <div class="action-row" *ngIf="showEditButton"> <!-- This container will hold all action items -->
          <div class="action-item">
            <!-- <p-button icon="pi pi-pencil" [rounded]="false" [text]="true" [raised]="true" severity="success"  (click)="showClientSettings()"></p-button> -->
          </div>
        </div>
      </div>
    </div>
<div *ngIf="!currentBinderService.isLoading() && clientDataService.clientData().length > 0 && !combine else combined">
<div class="flex flex-col gap-4 mb-4" *ngFor="let client of clientDataService.clientData()">
      <div class="info-action-row">
        <div class="ml-2 md:mr-2 flex">
          <i class="pi pi-user" *ngIf="client.primary" style="font-size: 2.5rem"></i>
          <i class="pi pi-users" *ngIf="!client.primary" style="font-size: 2.5rem"></i>
            <div class="mr-0 md:mr-1 ml-3">
              <span class="block text-900 font-medium mb-1">{{client.ClientFirstName}} {{client.ClientLastName}}</span>
              <div class="text-400"> <span *ngFor="let label of client.labels"> {{label.label}}</span></div>
            </div>
        </div>
        <div class="action-row" *ngIf="!showEditButton"> <!-- This container will hold all action items -->
          <div class="action-item">
            <p-select [(ngModel)]="client.selectedEmail" optionLabel="email" optionValue="email"
            [options]="client.emailItems" placeholder="Select an Email" (onChange)="updateEmail($event.value, client)">
          </p-select>
            <p-select [(ngModel)]="mode" optionLabel="label" optionValue="value"
            [options]="modes" placeholder="Select a Signature Mode" (onChange)="updateMode($event.value, client)">
          </p-select>
          </div>
        </div>
      </div>
    </div>
</div>

<ng-template #combined>
<div class="card flex flex-col gap-4 mt-4" *ngIf="!currentBinderService.isLoading() && clientDataService.clientData().length > 0">
          <div class="info-action-row">
            <div class="ml-2 md:mr-2 flex">
              <i class="pi pi-user" *ngIf="clientDataService.clientData().length > 1" style="font-size: 2.5rem"></i>
              <i class="pi pi-users" *ngIf="clientDataService.clientData().length < 2" style="font-size: 2.5rem"></i>
                <div class="mr-0 md:mr-1 ml-3">
                  <span class="block text-900 font-medium mb-1">{{combineNames()}}</span>
                  <div class="text-400"> <span>{{countClients()}} Signers</span></div>
                </div>
            </div>
        </div>
      </div>
</ng-template>
    `,
    styles: `

.info-action-row {
    display: flex;
    justify-content: space-between;
    align-items: center; /* This will vertically center align the items */
  }
  
  .info {
    display: flex;
    flex-direction: column;
    align-items: top; /* This will vertically center align the name and role */
  }

.action-row {
    display: flex;
    justify-content: flex-end; /* Align items to the left */
  }
  
  .action-item {
    margin-right: 5px;
    margin-top: 5px;
    margin-bottom: 5px;;
  }
    `
})
export class BinderClientsComponent {
  @Input() showEditButton = true;
  @Input() combine = true;
  modes = [ {label: 'Email', value: 'email'}, {label: 'In-Person', value: 'in-person'}];
  mode = 'email';
  combinedNames = '';

  constructor(
    public clientDataService: ClientService,
    private docDataService: DocDataService,
    public currentBinderService: BinderService
  ) {
  }

  updateEmail(email:string,client:ClientHybrid){
    const clientId = client.clientId;
    const displayName = client.ClientFirstName + " " + client.ClientLastName;
    if(clientId){
      this.clientDataService.updateSelectedEmail(clientId,email);
      this.docDataService.updateSelectedEmail(clientId,email, displayName || '');
    } else {
      console.log("No clientId provided")
    }
  }

  updateMode(mode:string,client:ClientHybrid){
    const clientId = client.clientId;
    const displayName = client.ClientFirstName + " " + client.ClientLastName;
    if(clientId){
      this.clientDataService.updateSelectedEmail(clientId,mode);
      this.docDataService.updateSelectedMode(clientId,mode);
    } else {
      console.log("No clientId provided")
    }
  }

  showClientSettings() {
    // this.binderDialogService.toggleDialog('Client Contract Setings','clientSettings',true);
  }

  countClients(){
    return this.clientDataService.clientData().length;
  }

  combineNames() {
    const peopleList = this.clientDataService.clientData();
    // Filter the list to include only clients
    const clients = peopleList

    // Define the accumulator's type directly in the reduce function
    const lastNameGroups = clients.reduce<{ [key: string]: string[] }>((acc, client) => {
      const lastName = client.ClientLastName; // Adjusted to match the peopleList object structure
      const firstName = client.ClientFirstName; // Adjusted to match the peopleList object structure
      if (!acc[lastName]) {
        acc[lastName] = [];
      }
      acc[lastName].push(firstName);
      return acc;
    }, {});

    const combinedNames = Object.entries(lastNameGroups).map(([lastName, firstNames]) => {
      if (firstNames.length > 1) {
        return `${firstNames.join(', ')} ${lastName}`;
      } else {
        return `${firstNames[0]} ${lastName}`;
      }
    });

    return combinedNames.join(', ');
  }

}
